import api from './api';

const payCardOpsService = {

  // ✅ Lookup student by admission number OR QR scan
  // admissionNumber is what shows on the admission screen: 1001, 1002, 1003...
  // This is also stored as the QR token in pay_cards table
  lookupStudent: (input) => {
    const trimmed = input.trim().toUpperCase();
    // Always send as ?qr= param — QR token = admissionNumber
    // So typing 1001 = same as scanning QR of that student
    return api.get(`/paycards/lookup?qr=${trimmed}`).then(r => r.data);
  },

  // Charge canteen
  chargeCanteen: (payCardId, items) =>
    api.post('/paycards/charge', {
      payCardId,
      category: 'CANTEEN',
      amount: items.reduce((s, i) => s + (i.price * (i.qty || 1)), 0),
      description: items.map(i => `${i.name} x${i.qty||1}`).join(', '),
      operatorName: 'Canteen',
    }).then(r => r.data),

  // Charge laundry
  chargeLaundry: (payCardId, items) =>
    api.post('/paycards/charge', {
      payCardId,
      category: 'LAUNDRY',
      amount: items.reduce((s, i) => s + (i.amount || 0), 0),
      description: items.map(i => `${i.name} x${i.qty}`).join(', '),
      operatorName: 'Laundry',
    }).then(r => r.data),

  // Charge electricity
  // Charge electricity (bulk — whole room bill; records bill history)
  chargeElectricityBulk: (req) =>
    api.post('/paycards/charge/electricity', req).then(r => r.data),

  // Charge one bed's electricity share (generic charge → returns balanceAfter;
  // avoids the room/month duplicate-bill block so per-bed deducts work)
  chargeElectricityBed: (payCardId, amount, roomCode, billingMonth) =>
    api.post('/paycards/charge', {
      payCardId,
      category: 'ELECTRICITY',
      amount,
      description: `Electricity · ${roomCode} · ${billingMonth}`,
      operatorName: 'Electricity',
    }).then(r => r.data),

  // Beds in a room with pay-card balances (for the electricity bed grid)
  getRoomBeds: (roomCode) =>
    api.get(`/paycards/room-beds?roomCode=${encodeURIComponent(roomCode)}`).then(r => r.data),

  // Charge electricity (legacy single request)
  chargeElectricity: (req) =>
    api.post('/paycards/electricity/charge', req).then(r => r.data),

  // Get canteen items
  getCanteenItems: () =>
    api.get('/paycards/canteen/items').then(r => r.data),

  // Save all canteen items (bulk replace) — returns the saved list
  saveAllCanteenItems: (items) =>
    api.put('/paycards/canteen/items', items).then(r => r.data),

  // Add canteen item
  addCanteenItem: (item) =>
    api.post('/paycards/canteen/item', item).then(r => r.data),

  // Update canteen item
  updateCanteenItem: (id, item) =>
    api.put(`/paycards/canteen/item/${id}`, item).then(r => r.data),

  // Delete canteen item
  deleteCanteenItem: (id) =>
    api.delete(`/paycards/canteen/item/${id}`).then(r => r.data),

  // Get laundry rates
  getLaundryRates: () =>
    api.get('/paycards/laundry/rates').then(r => r.data),

  // Save laundry rates
  saveLaundryRates: (rates) =>
    api.put('/paycards/laundry/rates', rates).then(r => r.data),

// Get laundry items (per-item pricing) 
 getLaundryItems: () => api.get('/paycards/laundry/items').then(r => r.data),

// Save all laundry items (bulk replace) 
saveAllLaundryItems: (items) => api.put('/paycards/laundry/items', items).then(r => r.data),
  
  // Get electricity history for a room
  getElectricityHistory: (roomCode) =>
    api.get(`/paycards/electricity/history?roomCode=${roomCode}`).then(r => r.data),

  // Check duplicate electricity bill
  checkDuplicateBill: (roomCode, billingMonth) =>
    api.get(`/paycards/electricity/check-duplicate?roomCode=${roomCode}&billingMonth=${billingMonth}`).then(r => r.data),

  // Get transactions for a pay card
  getTransactions: (payCardId) =>
    api.get(`/paycards/${payCardId}/transactions`).then(r => r.data),

  // List all pay cards (for QR management screen)
  getStudentQRList: () =>
    api.get('/paycards/list').then(r => r.data),

  // Top up a pay card
  topUp: (payCardId, amount, mode, reference, operator) =>
    api.post('/paycards/topup', {
      payCardId, amount, paymentMode: mode,
      referenceId: reference, operatorName: operator
    }).then(r => r.data),

  // Regenerate QR token
  regenerateQR: (payCardId) =>
    api.post(`/paycards/${payCardId}/regenerate-qr`).then(r => r.data),

  // Record a visitor (walk-in) canteen sale
  recordVisitorSale: (payload) =>
    api.post('/paycards/canteen/visitor-sale', payload).then(r => r.data),

  // List visitor sales
  getVisitorSales: () =>
    api.get('/paycards/canteen/visitor-sales').then(r => r.data),

};


export default payCardOpsService;